import {
  CalendarDateDimension,
  FinancialRateDimension,
  FinancialRateWithUnsetDimension,
  StringsEnumDimension,
  TextDimension,
} from '@orus.eu/dimensions'
import { frRcpaxeProductVersions, frRcpaxeSegments } from '@orus.eu/product'

export const frRcpaxeProductVersionDimension = new StringsEnumDimension({
  name: 'frRcpaxeProductVersion',
  displayKeys: { name: 'dimension_name_fr_rcpaxe_product_version' },
  values: frRcpaxeProductVersions,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const frRcpaxeSegmentDimension = new StringsEnumDimension({
  name: 'frRcpaxeSegment',
  displayKeys: { name: 'dimension_name_fr_rcpaxe_segment' },
  values: frRcpaxeSegments,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

//#region Fees
export const frRcpaxeDefaultManagementFeeRateDimension = new FinancialRateDimension({
  name: 'frRcpaxeDefaultManagementFeeRate',
  displayKeys: { name: 'dimension_name_fr_rcpaxe_default_management_fee_rate' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: false },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const frRcpaxeManuallySetManagementFeeRateDimension = new FinancialRateWithUnsetDimension({
  name: 'frRcpaxeManuallySetManagementFeeRate',
  displayKeys: { name: 'dimension_name_fr_rcpaxe_manually_set_management_fee_rate' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const frRcpaxeManagementFeeRateDimension = new FinancialRateDimension({
  name: 'frRcpaxeManagementFeeRate',
  displayKeys: { name: 'dimension_name_fr_rcpaxe_management_fee_rate' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const frRcpaxeDefaultInstallmentFeeRateDimension = new FinancialRateDimension({
  name: 'frRcpaxeDefaultInstallmentFeeRate',
  displayKeys: { name: 'dimension_name_fr_rcpaxe_default_installment_fee_rate' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: false },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const frRcpaxeManuallySetInstallmentFeeRateDimension = new FinancialRateWithUnsetDimension({
  name: 'frRcpaxeManuallySetInstallmentFeeRate',
  displayKeys: { name: 'dimension_name_fr_rcpaxe_manually_set_installment_fee_rate' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const frRcpaxeInstallmentFeeRateDimension = new FinancialRateDimension({
  name: 'frRcpaxeInstallmentFeeRate',
  displayKeys: { name: 'dimension_name_fr_rcpaxe_installment_fee_rate' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
//#endregion Fees

//#region Overcharges
const frRcpaxeOverchargeConfiguration = { min: 0, max: 10, step: 0.01 }

export const frRcpaxeCivilLiabilityOverchargeRateDimension = new FinancialRateDimension({
  name: 'frRcpaxeCivilLiabilityOverchargeRate',
  displayKeys: { name: 'dimension_name_fr_rcpaxe_civil_liability_overcharge_rate' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: true,
  inputLocking: undefined,
  configuration: frRcpaxeOverchargeConfiguration,
})
//#endregion Overcharges

export const frRcpaxeMinBirthDateDimension = new CalendarDateDimension({
  name: 'frRcpaxeMinBirthDate',
  displayKeys: { name: 'dimension_name_fr_rcpaxe_min_birth_date' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: false },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const frRcpaxeMaxBirthDateDimension = new CalendarDateDimension({
  name: 'frRcpaxeMaxBirthDate',
  displayKeys: { name: 'dimension_name_fr_rcpaxe_max_birth_date' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: false },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const frRcpaxeCustomActivityDimension = new TextDimension({
  name: 'frRcpaxeCustomActivity',
  displayKeys: { name: 'dimension_name_fr_rcpaxe_custom_activity', hint: 'dimension_hint_fr_rcpaxe_custom_activity' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const frRcpaxeCustomSummaryDimension = new TextDimension({
  name: 'frRcpaxeCustomSummary',
  displayKeys: { name: 'dimension_name_fr_rcpaxe_custom_summary', hint: 'dimension_hint_fr_rcpaxe_custom_summary' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
